import { createFileRoute } from '@tanstack/react-router'
import { CustomFields } from '../../../../../ui'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/custom-fields',
)({
	component: RouteComponent,
})

function RouteComponent() {
	return <CustomFields />
}
